"use strict";

/**
 * @classdesc
 *  Geometrie-Bearbeitungs-Modul-Panel.
 *
 * @class
 * @extends gc.gis.widget.GCPanel
 * @memberof gc.gis.module.GCDigitize
 * @author Christian Schmidt <c.schmidt@brain-scc.de>
 *
 * @param {Object} options Aufrufoptionen
 * @param {gc.gis.module.GCEditGeometry} options.module Modul-Instanz
 */
gc.gis.module.GCEditGeometry.Panel = function(options)
{
	gc.gis.assert.isSet(options);
    gc.gis.assert.isInstance(options.module, gc.gis.module.GCEditGeometry);

	/**
	 * @type {gc.gis.module.GCEditGeometry}
	 * @private
	 */
	this._module = options.module;

	/**
	 * Formular
	 * @type {gc.gis.util.GCForm|null}
	 * @private
	 */
	this._form = null;
	/**
	 * Speicher-Button.
	 * @type {gc.gis.widget.GCItem|null}
	 * @private
	 */
	this._btn_save = null;

	var options_widget = {
		className: 'gc-edit-geometry',
		actionbar: this._initActionbar()
	};

    gc.gis.widget.GCPanel.call(this, options_widget);

	// Inhalt erzeugen
    this.element = this._render();
    this._initContent();
};
gc.gis.module.GCEditGeometry.Panel.prototype = Object.create(gc.gis.widget.GCPanel.prototype);

/**
 * Aktualisiert die Oberfläche.
 *
 * @method
 * @param {Number} numChanged Anzahl der aktuell geänderten Features
 */
gc.gis.module.GCEditGeometry.Panel.prototype.updateForm = function(numChanged)
{
	this._btn_save.setEnabled(numChanged > 0);
};

/**
 * Initialisiert den Panel-Inhalt.
 *
 * @protected
 * @method
 */
gc.gis.module.GCEditGeometry.Panel.prototype._initContent = function()
{
	var self = this;

	// Panel Inhalt
	var controls = [];

	controls[controls.length] = {
		label: 'Welche Ebene soll bearbeitet werden?',
		name: 'edit_select_layer',
		type: 'select',
		options: [],
		initFunc: function (control)
		{
			self._module.on(gc.gis.module.GCEditGeometryEvent.LAYERS_UPDATED, self, function (evt) {
				control.updateOptions(control.updateFunc.call(this));
			});
		},
		updateFunc: function () {
			var layers = self._module.getEditableLayers();
			var keysSorted = Object.keys(layers).sort(function(a, b) {
				return layers[a].getName().localeCompare(layers[b].getName())
			});
			var currentLayer = self._module.getSelectedLayer();

			var options = [];
			options.push({
				label: '<bitte auswählen>',
				data: null
			});
			for (var i = 0, ii = keysSorted.length; i < ii; i++)
			{
				var key = keysSorted[i];
				options.push({
					label: layers[key].getLabel(),
					data: layers[key],
					selected: currentLayer === layers[key]
				});
			}
			return options;
		},
		change: function(evt, control)
		{
			const layer = control.getDataForSelection();
			if (layer !== self._module.getSelectedLayer())
			{
				self._fireEvent(gc.gis.module.GCEditGeometryEvent.LAYER_CHANGED, {
					layer: layer
				});
			}
		}
	};

	var snapCtrl = this._module.map.getSnapControl();
	if (snapCtrl) {
		controls = controls.concat(snapCtrl.getFormConfig());
	}

	var form_config = {
		controls: controls
		// validate: function(form, params) {},
		// submit: function(form, params) {},
		// error: function(form, err) {}
	};

	this._form = gc.gis.util.GCFormRenderer.renderForm(form_config);
	this.element_content.append(this._form.getElement());
};

/**
 * Initialisiert die Actionbar.
 *
 * @method
 * @return {Object}
 * @private
 */
gc.gis.module.GCEditGeometry.Panel.prototype._initActionbar = function()
{
	var self = this;

	this._btn_save = new gc.gis.widget.GCItem({
		label: 'Änderungen Speichern',
		className: 'btn btn-success',
		icon: 'action-apply',
		click: function(evt)
		{
			try
			{
				if (self._btn_save.isEnabled())
				{
					self._module.saveAll();
				}
			}
			catch(err)
			{
				gc.gis.iface.log.error(self, err);
			}
		}
	});

	return new gc.gis.widget.GCMenu({
		containerClassName: 'actionbar',
		items: [
			this._btn_save
		]
	})
};